module.exports = __webpack_public_path__ + "static/atf-bc772f76882252d4100c6b075af5fe07.png";